import { ComponentType } from '@angular/cdk/portal';
import { inject, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';
import { AppSnackBaseComponent, AppSnackConfig } from '../shared/components/snacks/snack-base.component';
import { AppSnackComponent } from '../shared/components/snacks/snack.component';
import { isNullOrUndefined } from '../shared/utils';
import { InfoSnackComponent, InfoSnackData } from '../shared/components/snacks/info-snack/info-snack.component';
import { ToastService } from './toast.service';

export const DEFAULT_DURATION = 3000;
export const DEFAULT_DURATION_AFTER_LEAVE = 3000;

@Injectable({
  providedIn: 'root'
})
export class SnackService {
  readonly toastService = inject(ToastService);

  errorSnack: MatSnackBarRef<AppSnackComponent>;

  constructor(public readonly snackBar: MatSnackBar) {
  }

  openFromComponent<T extends AppSnackBaseComponent, D = any>(
    component: ComponentType<T>,
    config?: AppSnackConfig<D>): MatSnackBarRef<T> {
    return this.snackBar.openFromComponent(component, <AppSnackConfig<D>>{
      horizontalPosition: 'center',
      verticalPosition: 'top',
      dismissOnClick: true,
      duration: DEFAULT_DURATION,
      durationAfterLeave: DEFAULT_DURATION_AFTER_LEAVE,
      ...config,
      panelClass: this.mergePanelClass('trg-snack', config?.panelClass)
    });
  }

  open<D = any>(message: string, config?: AppSnackConfig<D>): MatSnackBarRef<AppSnackComponent> {
    return this.openFromComponent(AppSnackComponent, {
      ...config,
      data: message
    });
  }

  openInfo(lableText: string, text: string, iconClass: string = "fas fa-solid fa-lightbulb-on", stylesClasses: string[] = []) {
    var infoSnackData: InfoSnackData = { iconClass, lableText, text }

    var snackRef = this.snackBar.openFromComponent(InfoSnackComponent, <MatSnackBarConfig<InfoSnackComponent>>{
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['trg-snack-info', 'trg-snack', ...stylesClasses],
      data: infoSnackData
    });

    return snackRef;
  }

  openError<D = any>(message: string, config?: AppSnackConfig<D>): MatSnackBarRef<AppSnackComponent> {
    // if an error snack is already opened, refresh it instead of creating a new snack
    if (this.errorSnack) {
      this.errorSnack.instance.message = message;
      this.errorSnack.instance.changeDetectorRef.detectChanges();
      this.errorSnack.instance.refreshTimeout();
      return;
    }

    this.errorSnack = this.open(message, {
      panelClass: this.mergePanelClass('trg-snack-error', config?.panelClass),
      dismissOnClick: true
    });

    this.errorSnack.afterDismissed().subscribe(() => {
      this.errorSnack = null;
    });
  }

  private mergePanelClass(panelClass: string | string[], otherPanelClass: string | string[]) {
    if (isNullOrUndefined(panelClass))
      panelClass = [];
    else
      if (typeof panelClass === 'string')
        panelClass = [panelClass];

    if (isNullOrUndefined(otherPanelClass))
      otherPanelClass = [];
    else
      if (typeof otherPanelClass === 'string')
        otherPanelClass = [otherPanelClass];

    return [...panelClass, ...otherPanelClass];
  }
}
